import React from 'react';

export default () => (
    <div className="view-header">
        <header className="title text-white">
            <h1 className="h4 text-uppercase">Match Payment</h1>
            <p className="mb-0">Match payment process</p>
        </header>
    </div>
);



// WEBPACK FOOTER //
// ./src/views/matchPayment/view-header.js